// ---Dependencies
import React from 'react';
// ---Layout
import { Spinner } from '../datastage/components/Spinner';
import DatastageRouter from '.././datastage/router';

/**
 * AuthorizedApp Component: Is the main app, providers and Hocs Can be added here
 * @returns {ReactElement}
 */
export const AuthorizedApp = () => (
    <>
        <Spinner />
        {/* Global Scope components can be added here */}
        <DatastageRouter />
    </>
);
